import { render, staticRenderFns } from "./ConfiguratoreTasti.vue?vue&type=template&id=5c236544&scoped=true&"
import script from "./ConfiguratoreTasti.vue?vue&type=script&lang=js&"
export * from "./ConfiguratoreTasti.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguratoreTasti.vue?vue&type=style&index=0&id=5c236544&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c236544",
  null
  
)

export default component.exports